<template>
  <div class="signup">
    <div class="container mt-3">
      <h2 class="title text-center pt-3">{{$t("message.select_ouccupation")}}</h2>
      <p class="text-center">{{$t("message.select_max_three")}}</p>
      <p class="text-center mb-0">
        <b-icon class="h3 mb-0" @click='showInfoModal' icon="question-circle"></b-icon>
      </p>
      <div class="row mt-5 mb-5">
        <div class="col-11 mx-auto px-0 mx-0">
          <b-button
            v-for="occupation in oc_lists"
            :key="occupation"
            type="button"
            class="mx-1 my-2 btn btn-white rounded-pill gray-button"
            v-on:click="setOccupation(occupation)"
            :id = "occupation"
          >
            {{$t("message." + occupation)}}
          </b-button>
          <span v-for="occupation in emergency_list" :key="occupation">
            <b-button
              v-if='!oc_lists.includes(occupation)'
              :key="occupation"
              disabled
              type="button"
              class="mx-1 my-2 btn btn-white rounded-pill gray-button-disabled"
              :id = "occupation"
            >
              {{$t("message." + occupation)}}
            </b-button>
          </span>
          <p v-if="occupationValid" class="error">{{$t("message.error_occupation")}}</p>
          <p v-if='select.length >= 3' class="pt-3"><b> {{$t('message.select_industry_description')}}</b></p>
        </div>
      </div>

      <div class="row mt-5 mb-5">
        <div class="col-6 col-lg-6 text-right">
          <b-button
            type="button"
            class="mx-1 my-2 btn rounded-circle gray-button-fill"
            style="width:4rem;height:4rem;"
            @click='changeMode("language")'
          >
            back
          </b-button>
        </div>

        <div class="col-6 col-lg-6 text-left">
          <b-button
            type="button"
            class="mx-1 my-2 btn rounded-circle blue-button"
            style="width:4rem;height:4rem;"
            @click='regist_occupation("profileInfo")'
          >
            next
          </b-button>
        </div>
      </div>
    </div>
    <info-modal ref="info"></info-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import InfoModal from "@/components/InfoModal"
export default {
  components: {
    InfoModal
  },
  data () {
    return {
      select: [],
      modal: false,
      occupation_list: [
        "industry_id_1",
        "industry_id_2",
        "industry_id_3",
        "industry_id_4",
        "industry_id_5",
        "industry_id_6",
        "industry_id_7",
        "industry_id_8",
        "industry_id_9",
        "industry_id_10",
        "industry_id_11",
        "industry_id_12",
        "industry_id_13",
        "industry_id_14"
      ],
      oc_lists: [],
      idList: {
        "industry_id_1": 1,
        "industry_id_2": 2,
        "industry_id_3": 3,
        "industry_id_4": 4,
        "industry_id_5": 5,
        "industry_id_6": 6,
        "industry_id_7": 7,
        "industry_id_8": 8,
        "industry_id_9": 9,
        "industry_id_10": 10,
        "industry_id_11": 11,
        "industry_id_12": 12,
        "industry_id_13":13,
        "industry_id_14": 14
      },
      occupationValid: false,
      idToken: localStorage.idToken,
      emergency_list: ['industry_id_3','industry_id_4','industry_id_5','industry_id_9']
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API + "/user/available_industry", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        response.data.forEach(d => {
              this.oc_lists.push("industry_id_" + d.id)
            })
      })

  },
  methods: {
    changeMode(mode){
      this.$emit('next', {mode: mode});
    },
    showInfoModal(){
      this.$refs.info.showModal(this.$i18n.t('message.title_help'), this.$i18n.t('message.occu_title_help'))
    },
    setOccupation(occupation){
      var check = document.getElementById(occupation);
      if(check.classList.contains("active")){
        this.select.push(this.idList[occupation])
        check.classList.remove("active");
      }
      else{
        if(this.select.length <= 2){
          var btn = document.getElementById(occupation);
          btn.classList.add("active");
          this.select.push(this.idList[occupation])
        }
        else{
          var first = this.select[0]
          const result = Object.keys(this.idList).filter( (key) => {
            return this.idList[key] === first
           });
          var btn_before = document.getElementById(result);
          btn_before.classList.remove("active");
          var btn_after = document.getElementById(occupation);
          btn_after.classList.add("active");
          this.select.shift()
          this.select.push(this.idList[occupation])
        }
      }
    },
    async regist_occupation(mode){
      if(this.select.length != 0){
        this.occupationValid = false
        var regist = {user:{sub: this.user.sub, interested_industry: this.select.join(','), current_industry: this.select[0], industry_id: this.select.join(',')}}
        await axios
          .patch(process.env.VUE_APP_API + "/users/" + this.user.id, regist, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.$store.commit('user/setUser', response.data)
            this.$emit('next', {mode: mode});
          }).catch(error => {
            console.log('this is error', error)
          })
      }
      else{
        this.occupationValid = true
      }
    }
  },
  computed: {
    ...mapState({
        user: state => state.user.user
    })
  },
}
</script>

<style scoped lang="scss">

  .error {
      border-color: red;
      background: mistyrose;
  }
  .btn-white{
    color: rgba(1, 1, 20, 0.87);
    border: 1px solid rgba(1, 1, 20, 0.12);
    background-color: white ;

    &:hover{
      color: #FFFFFF;
      border: 0px solid rgba(1, 1, 20, 0.12);
      background-color: #000054 !important;
    }
  }
  .active{
    color: #FFFFFF;
    border: 0px solid rgba(1, 1, 20, 0.12) !important;
    background-color: #000054 !important;
  }
</style>
